export enum QualificationName {
  AS_AND_A_LEVEL = 'AS and A Level, Core Maths, FSMQ',
  GCSE = 'GCSE',
  CAMBRIDGE_NATIONALS = 'Cambridge Nationals',
  CAMBRIDGE_TECHNICALS = 'Cambridge Technicals',
}
